
import { Button, IconButton } from '@mui/material';
import './Cedrus.css';
import cedrus1 from "../../../../../assets/cedrus/Lebanon-Cedar.jpg";
import cedrus2 from "../../../../../assets/cedrus/Deodar-Cedar.jpg";
import cedrus3 from "../../../../../assets/cedrus/atlatnica-cedars.jpg";
import BackIcon from '../../../../../components/back/back';

const cedrusFamilies = [
    { id: 1, name: "cedrus Libaon", img: cedrus1, url: "/flowers" },
    { id: 2, name: "cedrus Deodara", img: cedrus2, url: "/fruits" },
    { id: 3, name: "cedrus Atlantica", img: cedrus3, url: "/quercus" },

];



export default function CedrusFamiliesDesktop() {
    return (
        <div className='cedrus-big-container'>
            <BackIcon />
            <div className="cedrus-container">
                <div className="title-overlay">
                    <h1>Cedrus Collection</h1>
                </div>
                <div className="plants-category-container grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-8" style={{ marginTop: "5rem" }}>
                    {cedrusFamilies.map((cedrus) => (
                        <div key={cedrus.id} className="cedrus-shape-card bg-white p-6 rounded-xl shadow-lg transform transition-all hover:scale-105">
                            <img
                                src={cedrus.img}
                                alt={cedrus.name}
                                className="w-full h-60 object-cover rounded-lg mb-4"
                            />
                            <p className="plant-name">{cedrus.name}</p>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}
